import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB2bqc49W00YeZXE5AgmRwpeJx6JI_4Szk",
  authDomain: "kitchenlink-van.firebaseapp.com",
  projectId: "kitchenlink-van",
  storageBucket: "kitchenlink-van.firebasestorage.app",
  messagingSenderId: "869114829197",
  appId: "1:869114829197:web:fb83339e5d561aeace45c4"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
